import type { ConfigName } from "apps/visits/core/modules/vouchers-distribution/types/config-name";
import { useTranslation } from "react-i18next";
import type { VoucherDistribution } from "../../models/voucher-distribution";
import type { VoucherDistributionConfig } from "../../types/voucher-distribution-config";
import { VoucherConfigCard } from "../voucher-config-card";

type VoucherConfigsProps = {
  configs: VoucherDistributionConfig[];
  configName: ConfigName;
  consultations?: VoucherDistribution["consultations"];
};

export const VoucherConfigs = ({ configs, configName, consultations }: VoucherConfigsProps) => {
  const { t } = useTranslation();

  if (configs.length === 0) return null;

  return (
    <div className="mx-auto mt-32 max-w-4xl">
      <h3 className="mb-4 text-center font-serif text-xl lg:text-4xl">
        {t(`cmsTranslations.${configName}.continue.title`)}
      </h3>
      <p className="mb-12 text-center text-lg">{t(`cmsTranslations.${configName}.continue.description`)}</p>
      <div className="flex flex-col items-center gap-4 py-6">
        {configs.map((config) => {
          return <VoucherConfigCard key={config.path} voucherConfig={config} />;
        })}
        {consultations?.isEnabled && (
          <VoucherConfigCard
            voucherConfig={{
              image: consultations.imageUrl || "",
              title: t(`cmsTranslations.consultations.card.title`),
              description: t(`cmsTranslations.consultations.card.description`),
              path: consultations.path || "",
              buttonLabel: t(`cmsTranslations.consultations.card.button_label`),
              configName: "consultations",
            }}
          />
        )}
      </div>
    </div>
  );
};
